'use client';

import { cn } from '@/utils/cn';
import { Menu } from 'lucide-react';

export default function HamburgerButton() {
    return (
        <button
            type="button"
            onClick={() => {
                window.dispatchEvent(new CustomEvent('openMenuOverlay'));
            }}
            className={cn(
                'hamburger-button',
                'z-50 flex items-center justify-center p-2',
                'bg-haug-coral-100 text-haug-choco-100 hover:bg-haug-coral-200',
                'transition-colors duration-200 ease-in-out',
                'h-12 min-w-[48px]'
            )}
            aria-label="Menu"
        >
            <Menu size={24} />
        </button>
    );
}
